import React from "react";
import styles from "./ui.module.scss";
import { useEventStore } from "../../store";
import { TActionAuthor } from "../../../../stores/EventStore";
import redirectTo from "../../../../utils/redirectTo";

const EventOrganizerBlock: React.FC<{ data?: TActionAuthor }> = ({
  data = null,
}) => {
  let currAuthor: TActionAuthor;
  if (!data) {
    const { eventAuthor } = useEventStore();
    currAuthor = eventAuthor;
  } else currAuthor = data;

  const onClick = () => {
    if (currAuthor?.id && currAuthor?.type === "organization") {
      redirectTo(`/organization/${currAuthor?.id}`);
    }
    if (currAuthor?.id && currAuthor?.type === "bloodstation") {
      redirectTo(`/bloodstations/${currAuthor?.id}`);
    }
  };

  return (
    <div
      className={styles.EventOrganizerBlock}
      onClick={onClick}
      data-author={currAuthor?.type}
    >
      <div className={styles.EventOrganizerBlock_Container}>
        <div className={styles.EventOrganizerBlock_Container_Default}>
          {data ? "Ищет" : "Организатор"}
        </div>
        <div className={styles.EventOrganizerBlock_Container_Content}>
          {currAuthor?.image && (
            <div className={styles.EventOrganizerBlock_Container_Content_Image}>
              <img src={currAuthor?.image} alt="Изображение" />
            </div>
          )}
          {!currAuthor?.image && (
            <div className={styles.EventOrganizerBlock_Container_Content_Image}>
              <img
                src={"/static/images/icons/defaultUserAvatar.svg"}
                alt="default user image"
              />
            </div>
          )}
          <div className={styles.EventOrganizerBlock_Container_Content_Text}>
            {currAuthor?.name}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventOrganizerBlock;
